import React from "react";

import { ActivityHistoryData } from "../../../../common/classes/ActivityHistoryData";
import FormInput from "../../../../common/forms/FormInput";

import styles from "../EditBase.module.scss";
import formstyles from "./ResultsForm.module.scss";

interface Props {
  historyItems: Array<ActivityHistoryData>;
  addHistoryInput: () => void;
  deleteHistory: (i: number) => void;
  handleHistoryInputChange: (value: string | undefined, name: string) => void;
}

const EditPlayerHistories: React.FC<Props> = ({
  historyItems,
  addHistoryInput,
  deleteHistory,
  handleHistoryInputChange,
}) => {
  return (
    <div className={styles["p-edit__wrapper"]}>
      <div className={styles["p-edit__inner"]}>
        <div className={styles["p-edit__title"]}>
          活動実績の追加 / 編集
          <div className={styles["p-edit__title-desc"]}>
            大会や仕事などの実績を記入していると依頼のチャンスが増えます。
          </div>
        </div>
        {historyItems.map((result, i) => (
          <div className={formstyles["g-results"]} key={i}>
            <div className={formstyles["g-results__date"]}>
              <label className={formstyles["g-results__date-year"]}>
                <FormInput
                  type="text"
                  label=""
                  id=""
                  name={"year_" + i}
                  placeholder="- - - -"
                  style_class={`${styles["p-edit__form-input"]} ${formstyles["g-results__year-input"]}`}
                  initial_value={result.year}
                  handler={handleHistoryInputChange}
                />
                <span>年</span>
              </label>
            </div>
            <FormInput
              type="text"
              label=""
              id=""
              name={"title_" + i}
              placeholder="活動実績を入力"
              style_class={styles["p-edit__form-input"]}
              initial_value={result.title}
              handler={handleHistoryInputChange}
            />
            <button
              className={formstyles["g-results__btn-delete"]}
              type="button"
              key={i}
              onClick={() => deleteHistory(i)}
            ></button>
          </div>
        ))}
        <div
          className={formstyles["g-results__btn-add"]}
          onClick={() => addHistoryInput()}
        >
          &#043;
        </div>
      </div>
    </div>
  );
};

export default EditPlayerHistories;
